export default __webpack_public_path__ + "static/media/congratsCharacter.535ad824.png";